<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-popup
        v-model="showDialog"
        :cons="cons"
        hide-confirm
        hide-overlay
        max-width="900"
        transition="dialog-bottom-transition"
      >
        <template v-slot:helpinfo>
          <help-info
            :element-name="`${serviceName}-${componentName}-data-show-download-d`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('download_qr')"
          />
        </template>
        <v-card class="pa-5">
        <download-file-with-api
          v-if="showDialog"
          :address="`${data?.domain?.name||'qrland.in/'}${data.identifier}`"
          :qr_id="data?.qrId"
          :visit-name="data.visitName || ''"
          :preloaded-info="data"          
          :svg="qrSvgDataUrl"             
          @close="showDialog = false"
          :isQrlink="['qrlink','clickyarseo'].includes(data?.type?.toLowerCase())"
        />   
        </v-card>
      </custom-popup>
      <custom-tabs
        v-model="tabs"
        :tab-items="[
          { text: $t('fast_design') },
          { text: $t('professional_design') },
          { text: $t('ai_design') },
        ]"
        grow
        class="pa-3"
      >
        <template v-slot:staticItems>
          <!-- tab1 -->
          <v-tab-item class="py-4">
            <div class="p-5">
              <v-card :loading="loading" :class="$vuetify.breakpoint.smAndDown? '':'p-5'" flat>
                <v-row>
                  <v-col cols="12" md="4">
                <div class="sticky-preview">
                  <div class="preview-box">
                    <qr-maker :loading="loading" :svg="svgMade"/>
                    <v-btn
                      class="btn-download mt-3"
                      block
                      @click="showDialog = true"
                    >
                      <v-icon class="ml-1">mdi-progress-download</v-icon>
                      {{ $t("download_qr") }}
                    </v-btn>
                  </div>
                </div>
                  
                </v-col> 
                 <v-col v-if="!!qrDesign" cols="12" md="8">
                    <!-- <qr-customize v-model="qrDesign" :loading="loading"/> -->
                    <qr-code-make
                      ref="qrCanvas"
                      v-model="qrDesignD"
                      :file.sync="qrSvgDataUrl"
                      @save="autoSave"
                    />
                  </v-col>

                  <div class="py-5 mt-0 col-md-12">
                    <div class="rowinfo mt-0 mr-auto float-left justify-center">
                      <v-btn
                        :disabled="loading"
                        :loading="loading"
                        class="submit-btn"
                        @click="qrUpdate(true)"
                      >
                        <span
                          class="fa fa-save ml-1"
                          style="font-size: 15px"
                        ></span>
                        {{ $t("update_qr") }}
                      </v-btn>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-Qr-data-update`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        style="
                          align-self: center !important;
                          padding: unset !important;
                        "
                        :label="$t('update_qr')"
                      />
                    </div>
                  </div>
                </v-row>
              </v-card>
            </div>
          </v-tab-item>
          <!-- tab2-->
          <v-tab-item>
            <perfessional-design></perfessional-design>
          </v-tab-item>
          <!-- tab3 -->
          <v-tab-item class="py-4">
            <ai-design></ai-design>
          </v-tab-item>
        </template>
      </custom-tabs>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import QrCodeMake from "./qrCodeStyle/qrCodeMake.vue";
import PerfessionalDesign from "@/view/pages/qrland/perfessionalDesign.vue";
import AiDesign from "@/view/pages/qrland/aiDesign.vue";
import DownloadFileWithApi from "./downloadFileWithApi.vue";
import DownloadFile from "./downloadFile.vue"

export default {
  name: "designEdit",

  components: {
    QrCodeMake,
    QrMaker,
    QrCustomize,
    PerfessionalDesign,
    AiDesign,
    DownloadFileWithApi,
    DownloadFile
  },

  data() {
    return {
      svgMade:"",
      hasChanges: false,
      cardTexts: null,
      originData: null,
      qrId: null,
      cons: { title: this.$t("download_qr") },
      showDialog: false,
      tabs: 0,
      serviceName: "Qrland",
      componentName: "designEdit",
      helpData: [],

      qrDesign: null,
      qrSvgDataUrl: "",
      data: {},
      svg: "",
      loading: false,
    };
  },

  async mounted() {
    this.qrDesign = {
      qrStyleColors: {
        backcolor: "",
        frontColor: "",
        gradient_color: "",
        gradient: false,
        pattern: "default",
      },
      MarkerCenter: {
        topRight: "",
        bottomLeft: "",
        main: "",
        different_markers_color: false,
        eyePattern: "default",
      },
      QrMarkOut: {
        topRight: "",
        bottomLeft: "",
        markOutPattern: "default",
        main: "",
        different_markers_color: false,
      },
      QrFrame: {
        main: "",
        text: this.$t("scan_me"),
        framePattern: "none",
        different_markers_color: false,
      },
      LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
    };
    await this.fetchData();
    this.$nextTick(() => {
      this.tabs = this.tabs === 2 ? this.tabs : this.cardTexts?.tab_design || 0;
    });
    if (this.cardTexts?.tab_design && this.tabs !== 2) {
      let messsage =
        this.tabs === 0
          ? this.$t("fast_design_message")
          : this.$t("professional_design_message");
      this.$toast.success(messsage, { timeout: 5000 });
    }
  },

  computed: {
    qrDesignD: {
      get() {
        return typeof this.qrDesign === "string"
          ? JSON.parse(this.qrDesign)
          : this.qrDesign;
      },
      set(val) {
        this.qrDesign = val;
      },
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrIdf() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },

  methods: {
    async convertSvgUrlToData(svgUrl) {
      try {
        const response = await fetch(svgUrl);
        const svgText = await response.text();

        const base64Svg = btoa(svgText);
        return base64Svg;
      } catch (error) {
        return null;
      }
    },
    async fetchData() {
      this.loading = true;
      this.$api
        .get(
          this.$route.fullPath.includes("qr/design2")
            ? `/v1/testQr/find1/${this.domainName}`
            : `/v1/testQr/find/${this.domainName}${
                this.qrIdf ? "/" + this.qrIdf : ""
              }`
        )
        .then(({ data }) => {
          this.data = data.data;
          this.cardTexts = data.data.data.data;
          this.originData = data.data.data;
          const finalQrContent = this.data.link || `https://${this.data?.domain?.name || 'qrland.in/'}${this.data.identifier}`;

          this.qrId = this.data.qrId;
          this.tabs =
            this.tabs === 2 ? this.tabs : this.cardTexts?.tab_design ?? 0;
          if (this.cardTexts?.tab_design && this.tabs !== 2) {
            let messsage =
              this.tabs === 0
                ? this.$t("fast_design_message")
                : this.$t("professional_design_message");
            this.$toast.success(messsage, { timeout: 5000 });
          }

          // if (this.cardTexts.tab_design === 1) {
          //   //generate design randomly
          //   this.qrDesign = {};
          //   this.qrSvgDataUrl = "";
          // }
          if (
            this.cardTexts?.tab_design === undefined ||
            this.cardTexts?.tab_design === null ||
            this.cardTexts?.tab_design === 0 ||
            this.cardTexts?.tab_design === 1
          ) {
            if (this.data.img_url) {
              this.qrSvgDataUrl = this.data.img_url
                ? this.data.img_url
                : data?.data?.image;
              this.qrDesign =
                typeof data.data.qr === "string"
                  ? JSON.parse(data.data.qr)
                  : data.data.qr;
              if (
                !!finalQrContent &&
                (this.qrDesign.data === null ||
                  this.qrDesign.data === "" ||
                  this.qrDesign.data !== this.data.link)
              ) {
                this.qrDesign.data = finalQrContent;
              }
              this.$nextTick(() => {
                if (this.$refs.qrCanvas) {
                  this.$refs.qrCanvas.appendCanvas(finalQrContent);
                }
              });
              this.svg = data.data.svg;
            } else {
              this.qrSvgDataUrl = "";
              this.qrDesign = {
                qrStyleColors: {
                  backcolor: "",
                  frontColor: "",
                  gradient_color: "",
                  gradient: false,
                  pattern: "default",
                },
                MarkerCenter: {
                  topRight: "",
                  bottomLeft: "",
                  main: "",
                  different_markers_color: false,
                  eyePattern: "default",
                },
                QrMarkOut: {
                  topRight: "",
                  bottomLeft: "",
                  markOutPattern: "default",
                  main: "",
                  different_markers_color: false,
                },
                QrFrame: {
                  main: "",
                  text: this.$t("scan_me"),
                  framePattern: "none",
                  different_markers_color: false,
                },
                LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
                data: this.data.link,
              };
              this.$nextTick(() => {
                if (this.$refs.qrCanvas) {
                  this.$refs.qrCanvas.appendCanvas(this.data.link);
                }
              });
            }
          }
        })
        .finally(() => (this.loading = false));
    },
   async qrUpdate(final = false) {
      this.loading = true;

       // --- بخش اصلاح دیتای تصویر (SVG) ---
      let finalImage = this.qrSvgDataUrl;
      
      if (finalImage && finalImage.includes('http')) {
        const cleanUrl = finalImage.replace('data:image/svg+xml;base64,', '');
        
        try {
          const response = await fetch(cleanUrl);
          const svgText = await response.text();
          const base64Svg = btoa(svgText);
          finalImage = `data:image/svg+xml;base64,${base64Svg}`;
        } catch (error) {
          console.error("Error fetching SVG:", error);
          finalImage = cleanUrl; 
        }
      }
      // ------------------------------------

      const data = new FormData();
      if (this.$route.fullPath.includes("qr/design2")) {
        data.append("title", this.data.title);
        data.append("type", this.data.type);
        data.append("identifier", this.data.identifier);
        data.append("_method", "PUT");
        data.append("qr_id", this.data.qrId);
        data.append("image", finalImage); // استفاده از تصویر اصلاح شده
        data.append("qr", JSON.stringify(this.qrDesign));
      } else {
        data.append("domain", this?.data?.domain?.name);
        data.append("identifier", this.data.identifier);
        data.append("type", this.data.type);
        data.append("_method", "PUT");
        data.append("image", finalImage); // استفاده از تصویر اصلاح شده
        data.append("qr", JSON.stringify(this.qrDesign));
        data.append("qr_id", this.data.qrId);
      }
      const updatedCardTexts = {
        ...this.cardTexts,
        tab_design: this.tabs,
      };
      const updatedData = {
        ...this.originData,
        data: updatedCardTexts,
      };
      data.append("data", JSON.stringify(updatedData));

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          this.finish = final;
          this.goto("qr/list");
          this.$toast.success(this.$t("visit_card_edited_successfully"));
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    autoSave(options) {
      this.qrDesign =
        typeof options === "string" ? JSON.parse(options) : options;
      this.hasChanges = true;
    },
  },
  watch: {
    tabs(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.hasChanges = false;
      }
    },
  },
};
</script>
<style scoped>
.sticky-qr-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media (min-width: 960px) {
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 80px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 4;
    align-self: flex-start;

}
}
.design-edit-tabs .v-window,
.design-edit-tabs .v-window__container,
.design-edit-tabs .v-window-item {
  overflow: visible !important;
}
.preview-box {
  max-width: 320px;      /* یا هر عرضی که QR-maker داره */
  margin: 0px;
}
.btn-download {
  width: 85% !important;
  margin-left: 0px;
  margin-right: 0px;

}

</style>
